export default "__VITE_ASSET__gFw3o4Zu__"